module.exports = __webpack_public_path__ + "img/11.dff537c2.svg";